export const DEFAULT_COLUMNS = [
  "channel",
  "product",
  "geography",
  "curve_shape",
  "spend",
  "revenue",
  "units",
  "yield",
  "roi",
  "roas",
  "marginal_roas",
  "status",
  "max_efficiency",
  "marginal_roi",
  "difference_to_max",
  "lower_threshold",
  "upper_threshold",
  "weeks_in_market",
];
